import { Controller } from "@hotwired/stimulus"


export default class extends Controller {
  async connect() {
    if (!this.hasInitialized) {
      const module = await import("../vendors/aos");
      const AOS = module.default || module;
      AOS.init({
        once: true,
        duration: 800,
      });
      this.hasInitialized = true;
    } else {
      const module = await import("../vendors/aos");
      const AOS = module.default || module;
      AOS.refresh();
    }
    console.info("AOS Loaded");
  }
}
